import { render, staticRenderFns } from "./JDDetailModal.vue?vue&type=template&id=4d2399c6&scoped=true&"
import script from "./JDDetailModal.vue?vue&type=script&lang=js&"
export * from "./JDDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./JDDetailModal.vue?vue&type=style&index=0&id=4d2399c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2399c6",
  null
  
)

export default component.exports